import React from 'react';
import { Attribute, attributePreview } from './attributes';

type AttributePreviewProps = {
    attribute: Attribute;
};

export const AttributePreview = (props: AttributePreviewProps) => {
    const { attribute } = props;
    const Preview = attributePreview[attribute.fieldType];
    return attribute && <Preview attribute={attribute} />;
};
